import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import BlueImage from "../../assets/images/blue.jpeg";
import CandidateImage from "../../assets/images/HomePage/Slider/head-banner.jpg";
const Silder = () => {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const sliders = [
    {
      id: 3,
      image: CandidateImage,
    },
  ];

  return (
    <Carousel activeIndex={index} onSelect={handleSelect} id="home-slider">
      {sliders.map((slider, index) => {
        return (
          <Carousel.Item
            interval={200000000}
            key={index}
            style={{
              background: slider.background,
            }}
            className="rounded mt-2"
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100%" }}
            >
              <img
                className={slider.image ? "d-block" : "d-none"}
                src={slider.image}
                style={{ width: "100%", height: "100%" }}
                alt="First slide"
              />
              {slider.discraption ? (
                <div className="text-center font-weight-bold p-2 w-75 mx-auto h4 lh-lg">
                  {slider.discraption}
                </div>
              ) : null}
            </div>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
};

export default Silder;
